<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="vendors"
      class="elevation-1"
      :loading="loading"
      hide-default-footer
      disable-pagination
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>Vendors List</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>

          <v-dialog v-model="dialog" max-width="60%" v-if="roles.create_vendor">
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on"
                >Add Vendor</v-btn
              >
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" v-if="informText != ''">
                      <v-alert type="error">
                        {{ informText }}
                      </v-alert>
                    </v-col>
                    <v-col cols="6">
                      <v-text-field
                        v-model="editedItem.vendor_name"
                        label="Vendor Name"
                        @keyup="validation"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="6">
                      <v-text-field
                        v-model="editedItem.vendor_code"
                        label="Vendor Code"
                        @keyup="validation"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <!-- <v-btn color="blue darken-1" text @click="check">Check</v-btn> -->
                <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="save"
                  v-if="showBtn == true && roles.create_vendor"
                  >Save</v-btn
                >
                <v-btn color="blue darken-1" text @click="save" v-else disabled
                  >Save</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-btn color="primary" class="mb-2" v-else disabled>Add Vendor</v-btn>
        </v-toolbar>
      </template>
      <!-- <template v-slot:item.actions="{ item }" v-if="checkRoles('General Manager') || checkRoles('Administrator') || checkRoles('Fulfiller')"> -->
      <template v-slot:item.actions="{ item }">
        <v-row>
          <v-col cols="2">
            <v-btn
              color="primary"
              x-small
              @click="editItem(item)"
              v-if="roles.read_vendor"
            >
              <v-icon small> mdi-pencil </v-icon>
            </v-btn>
            <v-btn color="primary" x-small v-else disabled>
              <v-icon small> mdi-pencil </v-icon>
            </v-btn>
          </v-col>
          <!-- <v-col cols="2">
            <v-switch v-model="item.check" inset @change="changeStatus(item)"></v-switch>
          </v-col> -->
        </v-row>
      </template>
    </v-data-table>
  </div>
</template>


<script>
import axios from "axios";
//import moment from 'moment'
//import Vue from "vue";
//import HTTP from "../http-common"
import Amplify, { Auth } from "aws-amplify";

Amplify.configure({
  Auth: {
    region: "ap-southeast-1",
    userPoolId: "ap-southeast-1_8vBdk5PAd",
    userPoolWebClientId: "51e572vhkn38k7tuvsdst697b1",
    mandatorySignIn: true,
  },
});

export default {
  name: "Tags",
  //new Vue({
  data: () => ({
    loading: true,
    dialog: false,
    dropdown: [],
    re: [],
    AuthStr: "", //'Bearer '.concat(this.$cookies.get('token')),
    user: {
      _id: "",
      name: "",
    },
    headers: [
      {
        text: "Vendor Name",
        align: "start",
        value: "vendor_name",
      },
      { text: "Vendor Code", value: "vendor_code" },
      { text: "Status", value: "status" },
      { text: "Actions", value: "actions", sortable: false, width: "10%" },
    ],
    vendors: [],
    editedIndex: -1,
    product_type_item: "",
    size_item: "",
    url_item: "",
    editedItem: {
      vendor_name: "",
      vendor_code: "",
    },
    defaultItem: {
      vendor_name: "",
      vendor_code: "",
    },
    listVariants: [],
    listProductType: [],
    listSize: [],
    showBtn: null,
    informText: "",
    roles: [],
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Item";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },
  methods: {
    //URL
    // addURL(){
    //     var item = {
    //         product_type: this.product_type_item,
    //         size: this.size_item,
    //         template_url: this.url_item,
    //         listSize: []
    //     }
    //     for(const i of this.listSize){
    //         item.listSize.push(i)
    //     }

    //     this.editedItem.design_templates.push(item)

    //     this.product_type_item = "",
    //     this.size_item = "",
    //     this.url_item = ""
    //     this.listSize.length = 0
    // },

    // delURL(index){
    //     this.editedItem.design_templates.splice(index,1)
    // },

    //dropdown
    // async loadDataDropdown(){
    //   var currentSession = await this.$root.$refs.App.currentSession('vendor-loadDataDropdown')
    //   if(currentSession.accessToken){
    //     axios.get(window.domain + "product-types", { headers: { Authorization: currentSession.accessToken } })
    //     .then(response => {
    //         // If request is good...
    //         this.listVariants = response.data.data;
    //         this.loadProductType()
    //         //console.log(response)
    //     })
    //     .catch((error) => {
    //         console.log(error);
    //     });
    //   }else{
    //     console.log("currentSession vendor-loadDataDropdown-undefined: ",currentSession)
    //   }
    // },

    // loadProductType(){
    //     var temp = new Set()
    //     for(const i of this.listVariants){
    //         temp.add(i.product_type)
    //     }
    //     this.listProductType = Array.from(temp)
    // },

    // loadSize(product_type){
    //     var temp = new Set()
    //     for(const i of this.listVariants){
    //         if(i.product_type == product_type){
    //             temp.add(i.size)
    //         }
    //     }
    //     this.listSize = Array.from(temp)
    // },

    //action
    async loadData() {
      this.loading = true;
      var currentSession = await this.$root.$refs.App.currentSession(
        "vendor-loadData"
      );
      if (currentSession.accessToken) {
        axios
          .get(window.domain + "vendors", {
            headers: { Authorization: currentSession.accessToken },
          })
          .then((response) => {
            this.vendors = response.data.data;
            for (let j = 0; j < this.vendors.length; j++) {
              this.vendors[j]["check"] =
                this.vendors[j].status == "Active" ? true : false;
            }
            this.loading = false;
          })
          .catch((error) => {
            console.log("error " + error);
          });
      } else {
        console.log(
          "currentSession vendor-loadData-undefined: ",
          currentSession
        );
      }
    },

    // changeStatus(item){
    //   var index = this.vendors.indexOf(item)
    //   this.vendors[index].status = (this.vendors[index].check == true) ? "Active" : "Inactive"
    // },

    editItem(item) {
      this.$router.push("/vendors-edit/" + item._id);
    },

    // async deleteItem (item) {
    //   const index = this.vendors.indexOf(item)
    //   var r = confirm('Are you sure you want to delete this item?') && this.vendors.splice(index, 1)
    //   if(r != false)
    //   {
    //     var currentSession = await this.$root.$refs.App.currentSession('vendor-delete')
    //     //console.log('currentSession: ',currentSession.accessToken)
    //     if(currentSession.accessToken){
    //       axios.delete(window.domain + "vendors/"+item._id, {
    //         headers:{ Authorization: currentSession.accessToken }
    //       }).then(response => console.log("response Delete: ",response))
    //       .catch(error => console.log("Error: ",error));
    //     }else{
    //       console.log("currentSession vendor-delete-undefined: ",currentSession)
    //     }
    //   }
    // },

    close() {
      this.dialog = false;
      this.informText = "";
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    validation() {
      if (
        this.editedItem.vendor_name != "" &&
        this.editedItem.vendor_code != ""
      ) {
        this.showBtn = true;
      } else {
        this.showBtn = false;
      }
    },

    async save() {
      var currentSession = await this.$root.$refs.App.currentSession(
        "vendor-saveData"
      );
      if (currentSession.accessToken) {
        // if (this.editedIndex > -1) {
        //   var a = Object.assign(this.vendors[this.editedIndex], this.editedItem)
        //   fetch(window.domain + "vendors/"+a._id, {
        //     method:"PUT",
        //     headers:{ Authorization: currentSession.accessToken},
        //     body: JSON.stringify(this.editedItem)
        //   }).then(response => {response.json()})
        //   .then(data => {console.log(data);this.loadData();
        //   this.close()
        //   })
        //   .catch(error => {console.log(error)})

        // } else {
        fetch(window.domain + "vendors", {
          method: "POST",
          headers: { Authorization: currentSession.accessToken },
          body: JSON.stringify(this.editedItem),
        })
          .then((response) => response.json())
          //.then(data => {console.log("data: ",data);})
          .then((data) => {
            console.log("data response: ", data);
            if (data.error_message == "") {
              this.close();
              this.informText = "";
              this.vendors.push(data.data);
            } else {
              this.informText = data.error_message;
            }
          })
          .catch((error) => console.log("Error: ", error));
        // }
      } else {
        console.log(
          "currentSession vendor-saveData-undefined: ",
          currentSession
        );
      }
    },

    check() {
      console.log("editedItem", this.editedItem);
      console.log("product_type_item", this.product_type_item),
        console.log("size_item", this.size_item);
      console.log("url_item", this.url_item);
      console.log("listSize", this.listSize);
    },

    checkRoles(str) {
      var a = this.$root.$refs.App.hashCode(str);

      if (this.$cookies.get("roles") != null) {
        var role = this.$cookies.get("roles").split(",");
        var index = role.indexOf(a.toString());
        if (index != -1) return true;
        else return false;
      } else return false;
    },
  },

  async mounted() {
    this.roles = await this.$cookies.get("vendor");
    console.log("roles: ", this.roles);
    if (this.roles.list_vendors) {
      console.log("OK");
    } else {
      this.$router.push("/not-authorized");
    }

    try {
      await Auth.currentAuthenticatedUser({ bypassCache: false });
      this.loadData();
      //this.loadDataDropdown()
    } catch (error) {
      console.log("User logged out!");
      this.$router.push("/login");
    }
  },
};
</script>
